export default __webpack_public_path__ + "static/web-60a248a5620f89fa664ec599a06b323d.png";